import { render, staticRenderFns } from "./DetailGPPage.vue?vue&type=template&id=72d8f291&scoped=true&"
import script from "./DetailGPPage.vue?vue&type=script&lang=js&"
export * from "./DetailGPPage.vue?vue&type=script&lang=js&"
import style0 from "./DetailGPPage.vue?vue&type=style&index=0&id=72d8f291&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d8f291",
  null
  
)

export default component.exports